export const createGenericProblemDetails = (statusCode: number) => ({
  errorCode: 'GENERAL',
  title: 'General error',
  detail: 'An unknown error happened.',
  status: statusCode,
});

export const isProblemDetailsWithErrorCode = (responseData: unknown) => {
  return (
    typeof responseData === 'object' &&
    !!responseData &&
    'errorCode' in responseData &&
    typeof responseData.errorCode === 'string'
  );
};

/**
 * EWM-1066: provisioning lockouts are terminal, not per-request failures.
 *
 * When B2C hands us a token that cannot become a user row, every bootstrap call fails at once -
 * ten of them in the observed prod bursts. Each produced its own toast (they are keyed per
 * request, so EWM-905's dedup does not collapse them) on top of a splash screen that never
 * resolved, and the app was unusable with no explanation and no way out.
 *
 * Retrying cannot help: the fix is upstream in the IdP / B2C claim-mapping policy. So these codes
 * suppress the toast entirely and raise a single full-page contact-support state instead.
 *
 * String literals rather than the generated `ApiErrorCode` enum: the account app's swagger surface
 * does not include these codes, and both apps already compare them as literals.
 */
export const provisioningLockoutErrorCodes = [
  'USER_PROVISIONING_MISSING_EMAIL_CLAIM',
  'USER_PROVISIONING_INCOMPLETE_PROFILE',
] as const;

export const isProvisioningLockoutErrorCode = (errorCode: unknown): boolean =>
  typeof errorCode === 'string' &&
  (provisioningLockoutErrorCodes as readonly string[]).includes(errorCode);
